export default "__VITE_ASSET__ebba17c1__"